import { useState, useRef } from "react";
import "./accordion.css";

export default function Accordion({ title, children }) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef(null);

  return (
    <div className="accordion">

      <div
        className="accordion-header"
        onClick={() => setOpen(!open)}
      >
        <span>{title}</span>
        <span className={"arrow " + ((open) ? "rotate" : "")}>
          ▼
        </span>
      </div>

      <div
        ref={contentRef}
        className={"accordion-content " + ((open) ? "open" : "")}
      >
        <div className="accordion-inner">
          {children}
        </div>
      </div>

    </div>
  );
}
